// 组件
import importImg from '@/components/importImg.vue'
import alterForm from '@/components/alterForm'
// 接口
import { returnOrdersAdd, returnOrdersEdit, getPurchaseOrdersSimpleList, getReturnOrdersEditDetails } from '@/services/suppliers.js'
// 其他
import loading from '@/utils/loading.json'
import jsonData from './jsonData'
import constant from '@/utils/constant.js'

export default {
  name: 'returnOrderEdit',
  components: {
    importImg,
    alterForm
  },
  data () {
    return {
      modifyData: {},
      collapseLength: [],
      formData: jsonData.formData,
      itemStockSimpleList: [],
      simpleList: []
    }
  },
  watch: {
  },
  created () {
    this.init()
  },
  mounted () {
  },
  methods: {
    init () {
      this.collapseLength = [...new Array(this.formData.length).keys()]
      this.$store.state.app.loading = this.$loading(loading)
      const initRequest1 = getPurchaseOrdersSimpleList({ status: 'received' }).then(res => {
        this.formData[0].createDateItem[0].options = res.data.purchase_orders
        this.simpleList = res.data.purchase_orders
        return res
      }).catch(err => err)
      const requestArr = [initRequest1]
      if (this.$route.name === 'returnOrderEdit') {
        // 根据purchase_order_id获取商品
        // 获取详情接口
        this.formData[0].createDateItem[0].Object.disabled = true
        const initRequest2 = getReturnOrdersEditDetails(this.$route.params.id).then(res => {
          const return_order = Object.assign({}, res.data.return_order)
          return_order.return_order_items_attributes = res.data.return_order.return_order_items
          delete return_order.return_order_items
          this.modifyData = return_order
          return res
        }).catch(err => err)
        requestArr.push(initRequest2)
      }
      Promise.all(requestArr).then(res => {
        if (this.$route.name === 'returnOrderEdit') {
          this.formData[1].createDateItem[0].createDateFirstItem[0].options = this.getItemStockSimpleList(this.modifyData.purchase_order_id)
        }
      }).finally(() => {
        this.$store.state.app.loading.close()
      })
    },
    getItemStockSimpleList (data) {
      let options = []
      this.simpleList.map(item => {
        if (item.id === data) {
          item.purchase_order_items.map(order => {
            options = options.concat(order.shop_item_stock)
          })
          this.itemStockSimpleList = item.purchase_order_items
        }
      })
      return options
    },
    handleChange (data, prop, item, formData) {
      console.log(data, prop, item)
      if (prop === 'purchase_order_id') {
        this.formData[1].createDateItem[0].createDateFirstItem[0].options = this.getItemStockSimpleList(data)
      }
    },
    formSubmit (data) {
      // if (this.computedQuantity(data)) return
      this.$store.state.app.loading = this.$loading(loading)
      const obj = JSON.parse(JSON.stringify(data))
      const params = {
        return_order: obj
      }
      const api = this.$route.name === 'returnOrderEdit' ? returnOrdersEdit : returnOrdersAdd
      api(params, this.$route.params.id).then(res => {
        if (res.status === 200) {
          this.$message({
            type: 'success',
            message: this.$t('message.operateSuccess')
          })
          setTimeout(() => {
            this.$router.push({
              name: 'returnOrderManagerList'
            })
          }, constant.ROUTER_CHANGE_INTERVAL)
        }
      }).finally(() => {
        this.$store.state.app.loading.close()
      })
    },
    computedQuantity (data) {
      const result = []
      this.simpleList.map(purchase => {
        if (purchase.id === data.purchase_order_id) {
          purchase.purchase_order_items.map(item => {
            let count = 0
            data.return_order_items_attributes.map(option => {
              if (option.shop_item_stock_id === item.shop_item_stock_id) {
                count += option.quantity
              }
            })
            if (count > item.quantity) {
              const tip = this.$t('form.purchase.returnOrderTip', { name: item.shop_item_stock.name, count: item.quantity })
              result.push(tip)
            }
          })
        }
      })
      if (result.length > 0) {
        this.$message({
          dangerouslyUseHTMLString: true,
          message: result.join('<br/>'),
          type: 'error'
        })
      }
      return result.length > 0
    }
  }
}
